import React from 'react';
import MetricInfoPopover, { type MetricInfoDefinition } from '../ui/MetricInfoPopover';
import {
  opsMainClass,
  opsPageWrap,
  opsPanelBodyClass,
  opsPanelHeaderClass,
} from '../operations/operationsUi';

type InsightsPageShellProps = {
  title: string;
  description?: string;
  info?: MetricInfoDefinition;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

/** Full-height panel chrome aligned with Production Operations / WhatsApp hubs. */
const InsightsPageShell: React.FC<InsightsPageShellProps> = ({
  title,
  description,
  info,
  actions,
  children,
}) => (
  <div className={opsPageWrap}>
    <div className={opsMainClass}>
      <div className={opsPanelHeaderClass}>
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
          <div className="min-w-0">
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{title}</h2>
              {info && <MetricInfoPopover title={title} info={info} />}
            </div>
            {description && (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
            )}
          </div>
          {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
        </div>
      </div>
      <div className={opsPanelBodyClass}>
        <div className="space-y-6">{children}</div>
      </div>
    </div>
  </div>
);

export default InsightsPageShell;
